package org.braunequip.web.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

val ServiceCardContainer = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .overflow(Overflow.Auto)
            .flexDirection(FlexDirection.Row)
            .justifyContent(JustifyContent.Center)
            .alignItems(AlignItems.Center)
            .flexWrap(FlexWrap.Wrap)
            .margin(leftRight = autoLength)
            .padding(topBottom = 10.px)
    }
    Breakpoint.MD {
        Modifier
    }
}

val ServiceCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .display(DisplayStyle.Flex)
            .color(Colors.White)

            .width(500.px)
            .maxWidth(500.px)      //Set a maximum width to control size before
            .minHeight(400.px)
            .maxHeight(400.px)
            .margin(topBottom = 10.px)


            .boxShadow(0.px, 5.px, 15.px, color = Color.rgba(0, 0, 0, 0.1f))
            .border(2.px, LineStyle.Solid, Colors.White)
            .borderRadius(5.px)

            .transition(Transition.Companion.of("ease-in-out", .25.s))

            .flexBasis(80.percent)
            .flexGrow(0)           //Allow divs to grow if space is available
            .flexShrink(0)         //Allow divs to shrink as necessary
    }
    Breakpoint.MD {
        Modifier
            .margin(5.px)
            .flexBasis(25.percent)       //Keep this to allow for two columns
//            .flexGrow(0)           //Allow divs to grow if space is available
//            .flexShrink(0)         //Allow divs to shrink as necessary
    }
    hover {
        Modifier
            .transform {
                scale(1.025)
            }
    }
}

val ServiceCardDescOverlay = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .transition(Transition.Companion.of("ease-in-out", .25.s))

    }
}

val ServiceCardTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(2.8.cssRem)
            .textAlign(TextAlign.Center)
            .opacity(100)
            .textShadow(1.px, 1.px, 2.px, Color.rgba(0, 0, 0, 0.25f))
            .transition(Transition.Companion.of("ease-in-out", .5.s))
    }
}

val ServiceCardDescStyle = CssStyle {
    base {
        Modifier
        .fontSize(1.25.cssRem)
        .textAlign(TextAlign.Center)
        .opacity(100)
        .transition(Transition.Companion.of("ease-in-out", .5.s))
    }
    Breakpoint.MD {
        Modifier
            .fontSize(1.5.cssRem)
    }
}

@Composable
fun ServiceCard(image: String, title: String, description: String) {
    var focused by remember { mutableStateOf(false) }

    Div(ServiceCardStyle.toModifier()
        .backgroundImage(url(image))
        .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
        .backgroundSize(BackgroundSize.Cover)
        .toAttrs {
            onMouseOver { focused = true }
            onMouseLeave { focused = false }
        }) {

        Box(ServiceCardDescOverlay.toModifier()
            .overflow(Overflow.Scroll)
            .backgroundColor(
                if (focused) { Color.rgba(50,50,50,0.85.toFloat()) }
                else { Color.rgba(50,50,50, 0.50.toFloat())}
            ), contentAlignment = Alignment.Center) {


            if (focused) { P(ServiceCardDescStyle.toAttrs()) { Text(description) } }
            else { H2(ServiceCardTitleStyle.toAttrs()) { Text(title) } }
        }
    }
}